import React from 'react';
import { Form, Row, Col, Input, Button, Checkbox, message, Modal, Popover } from 'antd';
import { UserOutlined, LockOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import ckg from '../../assets/images/ckg.png';
import pclogo from '../../assets/images/pclogo.png';
import { _login, _sendSmsCode, _validateAccount, _confirmPassword, _submitLegalConfirmation } from '../../utils/api';
import { connect } from 'react-redux';
import * as actions from '../../store/Action';
import { getSearchParams } from '@/utils/get-search-params';
import { clearOrderSummaryCache } from '../../utils/config.js';
import { LEGAL_CONFIRMATION_LOGIN_PARAMS } from '../../utils/legal-confirmation';
import LegalConfirmationModal from '../LegalConfirmation';

const mapDispatchToProps = (dispatch) => {
  return { 
    set: (contacter) => dispatch(actions.SET_NAME({name: contacter})),
    setCrmAccountId: (crmAccountId) => dispatch(actions.SET_CRM_ACCOUNT_ID({ crmAccountId })),
  }
}
const mapStateToProps = (state) => {
  return {...state}
}

class Login extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      lock: false,
      loginame: '',               // 登录账号
      loginpwd: '',               // 登录密码
      smsModal: false,
      mobileload: false,
      codetime: 0,                // 验证码倒计时
      memberid: "",
      providermerchantid: '',
      character: 0,             // 0 个人  1企业 高校   供应商性质
      accountType: 0,           // 登录账号  非手机号->1  请联系供应商主体认证->2    账号未激活->3    联系供应商激活->4
      accountNumber: '',        // 获取验证码账号
      setPasswordModal: false,
      password: '',
      confirmPassword: '',
      authCode: '',
      resetLoading: false,
      legalChecked: false,
      legalModalVisible: false,
      legalSubmitting: false,
      legalTicket: '',
      legalAgreements: [],
      legalPageTitle: '',
      legalPageCopy: '',
      legalPreparing: false,
    }
  }

  /** 共用登录 */
  publiclogin = params => {
    this.setState({lock: true});
    _login({ ...params, ...LEGAL_CONFIRMATION_LOGIN_PARAMS }).then(res => {
      this.setState({lock: false}, () => {
        if (res && res.code === 200) {
          // 清除所有缓存数据，避免切换用户后数据错乱
          clearOrderSummaryCache();

          this.props.set(res.data.contacter || '');
          this.props.setCrmAccountId(res.data['crm_account_id'] || '');
          localStorage.setItem('s_provider_merchantid', res.data.providermerchantid);
          localStorage.setItem('loginame', params.loginame);
          localStorage.setItem('CRM_ACCOUNT_ID', res.data['crm_account_id'] || '');
          localStorage.setItem('CRM_ACCOUNT_NAME', res.data['crm_account_name'] || '');
          const defaultRedirect = res.data.default_redirect || '/home';
          this.props.history.push({
            pathname: defaultRedirect,
          });
          const redirect = getSearchParams().redirect;
          if (defaultRedirect === '/home' && redirect) {
            window.history.replaceState({}, '', atob(redirect));
          }
        } else if (res && res.code === 202) {
          this.showLegalConfirmation(res.data);
        } else if (res && res.code === 201) {
          this.setState({
            providermerchantid: res.data.providermerchantid,
            accountType: res.data.type, 
          })
        } else {
          message.error((res && res.msg) || '请求错误，请稍后重试');
        }
      });
    }).catch(() => {
      this.setState({lock: false});
      message.error('请求失败，请稍后重试');
    })
  };

  /** 认证 */
  approve = () => {
    const { providermerchantid } = this.state;
    this.setState({ accountType: 0 });
    this.props.history.push(`/authentication?providermerchantid=${providermerchantid}`);
  };

  confirmlogin = () => {
    const { loginame, loginpwd } = this.state;
    const params = { loginame, loginpwd };
    if (!loginame) {
      message.error('请填写账号');
      return;
    };
    if (!loginpwd) {
      message.error('请填写密码');
      return;
    };
    if (!this.state.legalChecked) {
      message.warning('请先勾选同意供应商平台当前协议与规则');
      return;
    }
    this.publiclogin(params);
  };

  handleLegalCheckboxChange = event => {
    if (!event.target.checked) {
      this.setState({ legalChecked: false });
      return;
    }

    const { loginame, loginpwd, legalPreparing } = this.state;
    if (legalPreparing) {
      return;
    }
    if (!loginame) {
      message.warning('请先填写账号');
      return;
    }
    if (!loginpwd) {
      message.warning('请先填写密码');
      return;
    }

    this.setState({ legalPreparing: true, legalChecked: false });
    _login({
      loginame,
      loginpwd,
      ...LEGAL_CONFIRMATION_LOGIN_PARAMS,
      legal_confirmation_prepare_only: 1,
    }).then(res => {
      this.setState({ legalPreparing: false });
      if (res && res.code === 202) {
        this.showLegalConfirmation(res.data);
      } else if (res && res.code === 200) {
        this.setState({ legalChecked: true });
      } else if (res && res.code === 201) {
        this.setState({
          providermerchantid: res.data.providermerchantid,
          accountType: res.data.type,
        });
      } else {
        message.error((res && res.msg) || '账号校验失败，请稍后重试');
      }
    }).catch(() => {
      this.setState({ legalPreparing: false });
      message.error('账号校验失败，请稍后重试');
    });
  };

  resetLegalConfirmation = nextState => {
    this.setState({
      ...nextState,
      legalChecked: false,
      legalTicket: '',
      legalAgreements: [],
    });
  };

  showLegalConfirmation = (data = {}) => {
    this.setState({
      legalChecked: false,
      legalModalVisible: true,
      legalTicket: data.temporary_login_ticket || '',
      legalAgreements: data.agreements || [],
      legalPageTitle: data.page_title || '',
      legalPageCopy: data.page_copy || '',
    });
  };

  submitLegalConfirmation = evidence => {
    this.setState({ legalSubmitting: true });
    _submitLegalConfirmation({
      temporary_login_ticket: this.state.legalTicket,
      agreed: true,
      scrolled_to_bottom: evidence.scrolledToBottom,
      complete_login: 0,
    }).then(res => {
      this.setState({ legalSubmitting: false });
      if (!res || res.code !== 200) {
        message.error((res && res.msg) || '确认失败，请重新登录');
        return;
      }
      this.setState({
        legalChecked: true,
        legalModalVisible: false,
        legalTicket: '',
        legalAgreements: [],
      });
      message.success('协议与规则已确认，请点击登录');
    }).catch(() => {
      this.setState({ legalSubmitting: false });
      message.error('确认失败，请稍后重试');
    });
  };

  cancelLegalConfirmation = () => {
    this.setState({
      legalChecked: false,
      legalModalVisible: false,
      legalTicket: '',
      legalAgreements: [],
    });
  };

  openPlatformProtocol = () => {
    window.open('/#/protocol', '_blank', 'noopener,noreferrer');
  };

  /** 忘记密码 */
  forgetCode = () => {
    this.setState({ smsModal: true, });
  };

  /** 关闭验证码验证 */
  cancelsend = () => {
    this.setState({ smsModal: false });
  };

  /** 获取手机验证码 */
  getCode = () => {
    const { accountNumber } = this.state;
    if (!accountNumber) {
      message.warn('请输入账号');
      return;
    }
    const params = { 'login_name': accountNumber };
    this.sendcode(params);
  };

  sendcode = params => {
    this.setState({ mobileload: true });
    _sendSmsCode(params).then(res => {
      this.setState({ mobileload: false });
      if (res.code === 200) {
        this.codeTimeout();
      } else {
        message.error(res.msg);
      }
    })
  };

  /** 验证码时间 */
  codeTimeout = () => {
    this.setState({ codetime: 60 }, () => {
      let ti = this.state.codetime;
      this.intervalId = setInterval(() => {
        ti--;
        this.setState({ codetime: ti }, () => {
          if (this.state.codetime<0) {
            this.setState({ codetime: 0 });
            clearInterval(this.intervalId);                // 清空句柄，暂停计时
            this.intervalId = null;
          }
        });
      }, 1000);
    });
  };

  validatorPassword = () => {
    const { password, confirmPassword } = this.state;
    return {
      validatePassword: () => {
        if (!password) {
          message.warn('请输入密码');
          throw new Error();
        }
      },
      validateConfirmPassword: () => {
        if (!confirmPassword) {
          message.warn('请确认密码');
          throw new Error();
        }
      },
      validatePasswordAccord: () => {
        if (confirmPassword !== password) {
          message.warn('密码不一致，请确认后操作');
          throw new Error();
        }
      },
      validatePasswordFormat: () => {
        const passwordRegex =  /^(?!.*[^A-Za-z0-9#?!@$%^&*-.]$)(?![a-z]*$)(?![A-Z]*$)(?![0-9]*$)(?![#?!@$%^&*-.]*$).{8,16}$/;
        if (!passwordRegex.test(password)) {
          message.warn('密码长度8~16位；数字、大小写字母及特殊字符至少两种');
          throw new Error();
        }
      },
    }
  };

  confirmModifyPassword = () => {
    const { accountNumber, authCode, password, confirmPassword } = this.state;
    try {
      const validatorPassword = this.validatorPassword();
      validatorPassword.validatePassword();
      validatorPassword.validateConfirmPassword();
      validatorPassword.validatePasswordAccord();
      validatorPassword.validatePasswordFormat();
    } catch {
      return;
    };
    const params = { login_name: accountNumber, code: Number(authCode), 'new_password': password, 'confirm_password': confirmPassword };
    this.setState({ resetLoading: true });
    _confirmPassword(params).then(res => {
      this.setState({ resetLoading: false });
      if (res.code === 200) {
        this.cancelModifyPassword();
        this.setState({ resetLoading: false });
        message.success('密码修改成功，请登录')
      } else {
        message.error(res.msg);
      }
    })
  };

  cancelModifyPassword = () => {
    this.setState({ password: '', confirmPassword: '', authCode: '', setPasswordModal: false });
  };

  validateAccount = () => {
    const { accountNumber, authCode } = this.state;
    if (!accountNumber) {
      message.warn('请输入账号');
      return;
    }
    if (!authCode) {
      message.warn('请输入验证码');
      return;
    }
    const params = { login_name: accountNumber, code: Number(authCode) };
    this.setState({ mobileload: true });
    _validateAccount(params).then(res => {
      this.setState({ mobileload: false });
      if (res.code === 200) {
        this.setState({ mobileload: false, smsModal: false, setPasswordModal: true, codetime: 0 });
        if (this.intervalId) {
          clearInterval(this.intervalId);                // 清空句柄，暂停计时
          this.intervalId = null;
        };
      } else {
        message.error(res.msg);
      }
    })
  };
  
  render() {
    const { loginame, loginpwd, smsModal, mobileload, authCode, codetime, accountType, accountNumber, setPasswordModal, resetLoading, password, confirmPassword, legalChecked, legalModalVisible, legalSubmitting, legalAgreements, legalPageTitle, legalPageCopy, legalPreparing } = this.state;
    return (
      <>
        <div className="referral-partners-banner-wrapper">
          <img
            className="referral-partners-banner"
            src={`${process.env.REACT_APP_CDN_ORIGIN}/c/supplier/images/referral_partners.png`}
            alt="供应商推荐banner"
          />
          <Popover
            overlayClassName="referral-partners-popover-wrapper"
            content={
              <div
                className="referral-partners-popover-content"
                style={{
                  backgroundImage: `url(${process.env.REACT_APP_CDN_ORIGIN}/c/supplier/images/qrcode_bg.png)`,
                }}
              >
                <img
                  src={`${process.env.REACT_APP_CDN_ORIGIN}/c/supplier/images/supplier_suggestion.png`}
                  alt="推荐页面的二维码"
                  className="supplier-suggestion-qrcode"
                />
              </div>
            }
            placement="bottom"
          >
            <div className="referral-partners-popover-trigger" />
          </Popover>
        </div>
        <Row className="login">
          <Col lg={13} xs={0} className="logo">
            <img src={pclogo} alt="科学指南针" />
            <img src={ckg} alt="供应商管理平台" />
            <div>
              <p>—— 研趣·科学指南针·科研服务领导者·供应商管理平台 ——</p>
              <p>服务热线：400-831-0631</p>
            </div>
          </Col>
          <Col lg={11} xs={24} className="form">
            <div className="rStyle step4">
            <h3 style={{fontSize: 22}}>欢迎登录供应商管理平台</h3>
              <div className="logintype">
                <span>账号密码登录</span>
              </div>
              <Input prefix={<UserOutlined />} placeholder="账号" size="large" value={loginame} onChange={e => this.resetLegalConfirmation({ loginame: e.target.value })} />
              <Input.Password prefix={<LockOutlined />} value={loginpwd} style={{marginTop: 16}} onChange={e => this.resetLegalConfirmation({ loginpwd: e.target.value })} placeholder="密码" size="large" />
              <div className="forgetCode">
                <span onClick={this.forgetCode}><QuestionCircleOutlined />忘记密码</span>
              </div>
              <div className="legal-confirmation-check">
                <Checkbox
                  checked={legalChecked}
                  disabled={legalPreparing}
                  onChange={this.handleLegalCheckboxChange}
                >
                  我已完整阅读、理解并同意遵守供应商管理平台《供应商合作协议》《测试服务供应商规范细则》《供应商管理平台申诉规则》《供应商隐私政策》及其他平台规则。
                </Checkbox>
              </div>
              <div className="platform-protocol-entry">
                <Button type="link" onClick={this.openPlatformProtocol}>查看平台协议与规则</Button>
              </div>
              <Button className="legal-confirmation-login-button" type="primary" block size="large" loading={legalPreparing} disabled={this.state.lock || legalPreparing || !legalChecked} onClick={this.confirmlogin}>登录</Button>
            </div>
          </Col>
          <Modal
            visible={accountType === 1}
            okText="立即认证"
            cancelText="暂不认证"
            onOk={this.approve}
            onCancel={() => this.setState({ accountType: 0 })}
            closable={false}
            maskClosable={false}
            centered={true}
          >
            尊敬的供应商，我们的账号系统升级啦，为了保障您的账户安全，构建更为长久可靠的合作关系，请您在此完成平台认证！系统升级后，所有的供应商均须<Button type="link">手机号</Button>作为登陆账号；如您的原登陆账号非您的手机号的，请您后续完成绑定操作，谢谢合作！
          </Modal>
          <Modal
            visible={accountType === 2}
            closable={false}
            maskClosable={false}
            centered={true}
            footer={[
              <Button type="primary"  key="1" onClick={() => this.setState({ accountType: 0 })}>我知道了</Button>
            ]}
          >
            请联系供应商负责人修改供应商性质
          </Modal>
          <Modal
            visible={accountType === 3}
            okText="立即认证"
            cancelText="暂不认证"
            onOk={this.approve}
            onCancel={() => this.setState({ accountType: 0 })}
            closable={false}
            maskClosable={false}
            centered={true}
          >
            尊敬的供应商伙伴，为了保障您的账户安全，构建更为长久可靠的合作关系，现需要您完成平台合作的认证流程（未认证将无法登录供应商系统）
          </Modal>
          <Modal
            visible={accountType === 4}
            closable={false}
            maskClosable={false}
            centered={true}
            footer={[
              <Button type="primary" key="1" onClick={() => this.setState({ accountType: 0 })}>我知道了</Button>
            ]}
          >
            请联系供应商负责人完成供应商认证后登陆
          </Modal>
          <Modal
            title="如需操作【忘记密码】，请先进行账号验证"
            visible={smsModal}
            confirmLoading={mobileload}
            maskClosable={false}
            destroyOnClose={true}
            closable={false}
            onCancel={this.cancelsend}
            onOk={this.validateAccount}
            wrapClassName="smscode-modal"
          >   
            <p className="cont-title">我们将给您的手机号发送验证码，请及时查收</p>
            <Col span={24}>
              <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                <Col span={24}>
                  <Form.Item label="账号">
                    <Input
                      placeholder="请输入"
                      onChange={e => this.setState({ accountNumber: e.target.value })}
                      value={accountNumber}
                    ></Input>
                  </Form.Item>
                  <Form.Item label="验证码">
                    <Input.Search
                      placeholder="请输入验证码"
                      value={authCode}
                      enterButton={codetime > 0 ? `重发${codetime}S` : "获取验证码"}
                      onSearch={this.getCode}
                      onChange={e => this.setState({ authCode: e.target.value })}
                      loading={codetime > 0 || mobileload}
                    ></Input.Search>
                  </Form.Item>
                </Col>
              </Form>
            </Col>
          </Modal>
          <Modal
              title="新密码设置"
              visible={setPasswordModal}
              maskClosable={false}
              destroyOnClose={true}
              onOk={this.confirmModifyPassword}
              onCancel={this.cancelModifyPassword}
              confirmLoading={resetLoading}
              closable={false}
            >
              <Col span={24}>
                <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                  <Col span={24}>
                    <Form.Item label="新密码">
                      <Input.Password
                        placeholder="请输入"
                        onChange={e => this.setState({ password: e.target.value })}
                        value={password}
                      ></Input.Password>
                    </Form.Item>
                    <Form.Item label="确认密码" extra="注：密码长度8~16位；数字、大小写字母及特殊字符至少两种">
                      <Input.Password
                        placeholder="请输入"
                        onChange={e => this.setState({ confirmPassword: e.target.value })}
                        value={confirmPassword}
                      ></Input.Password>
                    </Form.Item>
                  </Col>
                </Form>
              </Col>
            </Modal>
          <LegalConfirmationModal
            visible={legalModalVisible}
            submitting={legalSubmitting}
            agreements={legalAgreements}
            pageTitle={legalPageTitle}
            pageCopy={legalPageCopy}
            onCancel={this.cancelLegalConfirmation}
            onConfirm={this.submitLegalConfirmation}
          />
        </Row>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
